import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import Ad from '../Ad/Ad';
import Classes from './AdsList.module.scss';
import formatPrice from '../../utils/formatPrice';
import { TAd } from 'types/Listings';

type TAdsListProps = {
  ads: TAd[];
};

function AdsList({ ads }: TAdsListProps) {
  const { t } = useI18nContext();
  return (
    <>
      {ads.map(({ imageUrl, price, title, vipUrl }) => (
        <Ad
          key={vipUrl}
          className={Classes.adContainer}
          imageUrl={imageUrl}
          title={title}
          price={formatPrice(price, t)}
          url={vipUrl}
        />
      ))}
    </>
  );
}

export default AdsList;
